export default __webpack_public_path__ + "static/media/unchecked.018e5246.svg";